import React, { useState, useEffect } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Toolbar, Box, Button, Typography, IconButton, Grid, Container,useTheme,useMediaQuery } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar';
import { DEFAULT_ATTACHMENT_PROMPTS } from '../../Components/Attachment';
import Composer from '../../Components/Composer';
import { NEW_CHAT_EVENT } from '../../Components/ChatMenu';
import '../../Assets/css/ChatUI.css';
import ModeSelector, { CHAT_MODE_KEY, CHAT_CLOUD_KEY, getModeConfig, readStoredMode, readStoredCloud } from '../../Components/ModeSelector';
import './HomePage.css';

const HomePage = ({ username, handleLogout, isAuthenticated }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [randomQuestions, setRandomQuestions] = useState([]);
  const navigate = useNavigate();
  const [mode, setMode] = useState(readStoredMode);
  const [cloud, setCloud] = useState(readStoredCloud);
  const [attachment, setAttachment] = useState(null);
  const activeAttachment = mode === 'rag' || mode === 'opm' ? null : attachment;
  // Example prompts for the modes that answer from the user's own input
  const examplePrompts = {
    review: [
      "Review my plan: lift-and-shift 40 VMs to Azure, public IPs for admin access, nightly backups to one storage account",
      "We run SAP ECC on DB2 with a single DB VM and no HA. What should we improve before migrating?",
      "Review this: AKS cluster with a public API server, one node pool, no network policies, secrets in env vars",
      "Our DR plan is a manual restore in a second region from daily backups. How can we improve RTO and RPO?",
    ],
    terraform: [
      "Azure hub-spoke network with Azure Bastion and 2 Linux VMs behind a load balancer in West Europe",
      "AWS VPC across 2 AZs with an ALB, Auto Scaling group of EC2 instances and RDS MySQL Multi-AZ",
      "GCP private GKE Autopilot cluster with Cloud SQL Postgres on a private IP",
      "Azure Site Recovery to replicate SAP VMs from West Europe to North Europe with a recovery vault",
    ],
    opm: [
      "What critical alarms are active right now?",
      "Are all probes connected? Which sites are not reporting?",
      "Which servers have high CPU or low disk space?",
      "Explain the active alarms on Router-PUN-01 and what to check first",
    ],
  };
  const preAskedQuestions = [
"Which team members are responsible for validating the DR environment?",
    "Which SAP environments are in scope for Phase 11 migration",
    "Why is hybrid connectivity required for SAP STMS?",
    "Which Azure VMs are required for an SAP DB2 system migration",
    "What is the purpose of HADR during DB2 migration?",
    "What must be verified before starting a test failover?",
    "What does the re‑protect option enable after failover?"  ];

  useEffect(() => {
    const selectedQuestions = preAskedQuestions.sort(() => 0.5 - Math.random()).slice(0, 6);
    setRandomQuestions(selectedQuestions);
  }, []); 

  useEffect(() => {
    localStorage.setItem(CHAT_MODE_KEY, mode);
  }, [mode]);
  useEffect(() => {
    localStorage.setItem(CHAT_CLOUD_KEY, cloud);
  }, [cloud]);

  const displayedQuestions = mode === 'rag' ? randomQuestions : examplePrompts[mode];

  // "New chat" in the sidebar: reset this page even if it is already open
  useEffect(() => {
    const handleNewChat = (event) => {
      if (event.detail?.mode) setMode(event.detail.mode);
      setSearchTerm('');
      setAttachment(null);
      setError('');
    };
    window.addEventListener(NEW_CHAT_EVENT, handleNewChat);
    return () => window.removeEventListener(NEW_CHAT_EVENT, handleNewChat);
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const fetchData = async () => {
    if (searchTerm.trim() === '' && !activeAttachment) {
      setError("It seems you haven't entered a question. Please try again.");
      return;
    }
    setError('');
    // A file can be sent on its own; use a sensible default instruction
    const question = searchTerm.trim() || DEFAULT_ATTACHMENT_PROMPTS[mode];
    localStorage.setItem('question', question);
    localStorage.setItem('askedQuestion', 'true');
    navigate('/chat', { state: { question, mode, cloud, attachment: activeAttachment } });
  };

  const handleSearch1 = async (question) => {
    localStorage.setItem('question', question);
    localStorage.setItem('askedQuestion', 'true');
    setSearchTerm(question);
    navigate('/chat', { state: { question: question, mode, cloud } });
  };

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return 'Good Morning, ';
    } else if (currentHour < 16) {
      return 'Good Afternoon, ';
    } else {
      return 'Good Evening, ';
    }
  };

  const storedData = localStorage.getItem('formData');
  const data = JSON.parse(storedData);

  useEffect(() => {
    if (data) {
      localStorage.removeItem('question');
      localStorage.removeItem('chatHistory');
      localStorage.removeItem('initialFetchDone');
      localStorage.removeItem('responsePending');
      localStorage.removeItem('conversation_history');
    }
  }, [data]);


  const greeting = getGreeting();

  const capitalizeFullName = (fullname) => {
    const parts = fullname.split(' ');
    if (parts.length === 1 && fullname.length > 15) {
      return fullname.slice(0, 15);
    }
    const firstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
    return firstPart;
  };

//   const capitalizeFullName = (fullname) => {
//   if (!fullname || typeof fullname !== "string") {
//     // before login or invalid value
//     return ""; // or return "Guest"
//   }

//   const parts = fullname.split(" ");

//   if (parts.length === 1 && fullname.length > 15) {
//     return fullname.slice(0, 15);
//   }

//   const firstPart =
//     parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();

//   return firstPart;
// };


  const formattedName = capitalizeFullName(username);
  const theme1 = useTheme();
  const isXsScreen = useMediaQuery(theme1.breakpoints.only('xs'));
  const isSmScreen = useMediaQuery(theme1.breakpoints.only('sm'));
  const isMdScreen = useMediaQuery(theme1.breakpoints.only('md'));

  const getTopPosition = () => {
    if (isXsScreen) return '7%';
    if (isSmScreen) return '7%';
    if (isMdScreen) return '6%';
    return '10%'; // default for larger screens
  };
 
// const randomQuestions = preAskedQuestions.sort(() => 0.5 - Math.random()).slice(0, 6);


  const modeSubtitle = {
    rag: 'Ask anything about your migration documents, runbooks and plans.',
    review: 'Paste requirements, an architecture, a plan or code, or attach a CMDB export, and get prioritised enhancements.',
    terraform: 'Describe the infrastructure you need, or attach an inventory, and get a validated Terraform project.',
    opm: 'Ask about alarms, servers, network devices and probes. Answers come from live OpManager data (read-only).',
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fff' }}>
      {/* Sidebar Toggle Icon */}
      {!sidebarOpen && (
        <IconButton
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
          sx={{ position: 'fixed', top: '72px', left: '16px', zIndex: 1300, backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(21,48,82,0.12)', '&:hover': { backgroundColor: '#f3f6fa' } }}
        >
          <MenuIcon sx={{ color: '#153052' }} />
        </IconButton>
      )}

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        currentPage="homepage"
        sidebarOpen={sidebarOpen}
        sx={{
          width: sidebarOpen ? '20%' : '0', // Sidebar width for larger screens
          transition: 'width 0.3s ease',
          '@media (max-width: 600px)': {
            width: sidebarOpen ? '100% ' : '0 ', // Sidebar covers whole screen on small devices
          }
        }}
      />

      {/* Main Content */}
      <Box
        className="home-hero"
        sx={{
          ml: sidebarOpen ? '20%' : 0,
          transition: 'margin-left 0.3s ease',
          '@media (max-width: 609px)': { ml: 0, display: sidebarOpen ? 'none' : 'flex' },
        }}
      >
        <div className="home-column">
          <h1 className="home-greeting">
            {greeting}<span>{formattedName}</span>
          </h1>
          <p className="home-subtitle">{modeSubtitle[mode]}</p>

          <ModeSelector mode={mode} onModeChange={setMode} cloud={cloud} onCloudChange={setCloud} />

          {error && <p className="home-error">{error}</p>}

          <Composer
            value={searchTerm}
            onChange={handleSearch}
            onSend={fetchData}
            placeholder={mode === 'rag' ? 'Ask a question, or pick one below...' : getModeConfig(mode).placeholder}
            showAttach={mode !== 'rag' && mode !== 'opm'}
            attachment={activeAttachment}
            onAttach={(file) => { setAttachment(file); setError(''); }}
            onRemoveAttachment={() => setAttachment(null)}
            onAttachError={setError}
            hint={mode !== 'rag' ? 'Attach a CMDB export, inventory or config file' : null}
            autoFocus
          />

          <div className="home-suggestions-label">
            {mode === 'rag' ? 'Most asked questions' : 'Try an example'}
          </div>
          <div className="home-suggestions">
            {displayedQuestions.map((question, index) => (
              <button key={index} type="button" className="home-suggestion" onClick={() => handleSearch1(question)}>
                <span className="home-suggestion-icon">{getModeConfig(mode).icon}</span>
                <span>{question}</span>
              </button>
            ))}
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default HomePage;
